import styled from 'styled-components';
import { spacings } from '../../../../../tokens/spacings';
import { Autocomplete } from '@equinor/eds-core-react';

export const AutocompleteWrapper = styled.div`
  display: flex;
  flex: 1 1 0%;
  flex-direction: row;
  align-items: flex-start;
  min-width: 0;

  column-gap: ${spacings.MEDIUM};
`;

export const AutoComplete = styled(Autocomplete)`
  min-width: 25%;

  /* When readOnly, EDS renders no adornment buttons but still reserves 56px of
     padding-right for them. Override to just the base spacing so text isn't truncated. */
  input[readonly] {
    padding-right: ${spacings.SMALL};
  }
` as unknown as typeof Autocomplete;

export const AutocompleteRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 0%;
  column-gap: ${spacings.MEDIUM};
  min-width: 0;

  > div {
    flex: 1 1 0%;
    min-width: 0;
    > div {
      > label {
        white-space: nowrap;
      }
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`;

export const MetadataWrapper = styled.div`
  min-width: 0;

  > div {
    > label {
      white-space: nowrap;
    }
  }
`;
